module.exports = __webpack_public_path__ + "img/code.e34cc5d9.png";